// PHASE 5: Statistics feedback on design values
import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function DesignValuesFeedbackPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <FeedbackPage
      emoji="📊"
      heading={t('pages.onboarding.v2.designValuesFeedback.heading')}
      text={t('pages.onboarding.v2.designValuesFeedback.description')}
      onSubmit={handleSubmit}
    />
  )
}
